import { AnyObject } from "final-form";
import i18next from "config/i18next";
import { ValidateTimeIntervalParamsType } from "utils/types";
import {
  validateHourDifference,
  validateTimeInterval,
} from "utils/validations";
import * as yup from "yup";
import "./i18n";
import "../../slots/slotsDetail/slotCreationModal/i18n";

const requiredMessage = i18next.t("validations:required");

const validationHourParams = {
  minDifference: 60,
  minMessage: i18next.t("rainBonus:timeDifferenceError"),
  field: "rainTime.end",
};

const validationTimeIntervalParams: ValidateTimeIntervalParamsType = {
  message: i18next.t("slotCreation:timeIntervalError"),
  field: "",
  interval: 15,
};

const validateRainTime = (context: yup.TestContext<AnyObject>) =>
  validateHourDifference(context, validationHourParams);

const validateRainIntervalTime = (
  value: string,
  context: yup.TestContext<AnyObject>,
  field: string
) =>
  validateTimeInterval(value, context, {
    ...validationTimeIntervalParams,
    field,
  });

const validateRainTimeOverlap = (
  value: string | undefined,
  errorCode: boolean,
  context: yup.TestContext<AnyObject>
) => {
  const { createError } = context;
  let message = errorCode && value ? i18next.t("rainBonus:overlapError") : null;
  if (message) {
    return createError({
      message,
    });
  }

  return true;
};

const rainTimeInitial = (timeError: boolean) =>
  yup
    .string()
    .test("timeValidation", (value, context) => validateRainTime(context))
    .test("intervalValidation", (val, ctx) =>
      validateRainIntervalTime(val || "", ctx, "rainTime.initial")
    )
    .test("overlapValidation", (val, ctx) =>
      validateRainTimeOverlap(val, timeError, ctx)
    );

const rainTimeEnd = (timeError: boolean) =>
  yup
    .string()
    .test("intervalValidation", (val, ctx) =>
      validateRainIntervalTime(val || "", ctx, "rainTime.end")
    )
    .test("timeValidation", (value, context) => validateRainTime(context))
    .test("overlapValidation", (val, ctx) =>
      validateRainTimeOverlap(val, timeError, ctx)
    );

const rainTimeCretion = (timeErrorCode: { initial: boolean; end: boolean }) =>
  yup.object({
    initial: rainTimeInitial(timeErrorCode.initial),
    end: rainTimeEnd(timeErrorCode.end),
  });

const rainTimeUpdate = (timeErrorCode: { initial: boolean; end: boolean }) =>
  yup.object({
    initial: rainTimeInitial(timeErrorCode.initial).required(requiredMessage),
    end: rainTimeEnd(timeErrorCode.end).required(requiredMessage),
  });

export const createRainValidationSchema = (timeErrorCode: {
  initial: boolean;
  end: boolean;
}) =>
  yup.object({
    rainDate: yup.string(),
    rainTime: rainTimeCretion(timeErrorCode),
  });

export const updateRainValidationSchema = (timeErrorCode: {
  initial: boolean;
  end: boolean;
}) =>
  yup.object({
    rainDate: yup.string().required(requiredMessage),
    rainTime: rainTimeUpdate(timeErrorCode),
  });
